import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["track", "slide", "dot"]

  connect() {
    this.updateDots()
    this.handleScroll = this.handleScroll.bind(this)
    this.trackTarget.addEventListener("scroll", this.handleScroll, { passive: true })
  }

  disconnect() {
    this.trackTarget.removeEventListener("scroll", this.handleScroll)
    cancelAnimationFrame(this.scrollFrame)
  }

  select(event) {
    const index = Number.parseInt(event.currentTarget.dataset.marketingCarouselIndex, 10)
    const slide = this.slideTargets[index]

    if (!slide) return

    this.trackTarget.scrollTo({
      left: slide.offsetLeft - this.trackTarget.offsetLeft,
      behavior: "smooth"
    })
  }

  handleScroll() {
    cancelAnimationFrame(this.scrollFrame)
    this.scrollFrame = requestAnimationFrame(() => this.updateDots())
  }

  updateDots() {
    if (!this.hasTrackTarget || this.slideTargets.length === 0) return

    const trackLeft = this.trackTarget.scrollLeft
    const maxScrollLeft = Math.max(0, this.trackTarget.scrollWidth - this.trackTarget.clientWidth)
    let activeIndex = 0
    let smallestDistance = Number.POSITIVE_INFINITY

    if (maxScrollLeft > 0 && trackLeft >= maxScrollLeft - 1) {
      activeIndex = this.slideTargets.length - 1
    } else {
      this.slideTargets.forEach((slide, index) => {
        const distance = Math.abs((slide.offsetLeft - this.trackTarget.offsetLeft) - trackLeft)

        if (distance < smallestDistance) {
          smallestDistance = distance
          activeIndex = index
        }
      })
    }

    this.dotTargets.forEach((dot, index) => {
      dot.toggleAttribute("aria-current", index === activeIndex)
    })
  }
}
